/* ============================================================
   Modulo Review Marquee — seamless infinite scroll.

   Mirrors the photo-marquee engine, per track:
   - Measure one "cycle" = width of the original cards + one gap each.
   - Clone enough copies that the track ≥ viewport + 1 cycle, so
     off-screen content is always queued on both sides.
   - Set --modulo-tm-cycle-width so CSS animates by exact pixels,
     landing on a clean cycle boundary every loop — no snap, no CLS
     (animation only attaches once the track is measured + ready).
   - Reduced motion: skip entirely (CSS freezes the rows).
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getGap(el) {
    var style = getComputedStyle(el);
    var raw = style.columnGap || style.gap || '0';
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  }

  function measureCycle(originals, gap) {
    var w = 0;
    for (var i = 0; i < originals.length; i++) {
      w += originals[i].getBoundingClientRect().width;
    }
    // One gap per item so the cycle includes its trailing gap,
    // keeping the loop boundary aligned between repeats.
    return w + gap * originals.length;
  }

  function makeClone(node) {
    var clone = node.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('role');
    // Never duplicate theme-editor block handles onto clones.
    clone.removeAttribute('data-shopify-editor-block');
    clone.removeAttribute('id');
    return clone;
  }

  function cloneSet(track, originals) {
    for (var i = 0; i < originals.length; i++) {
      track.appendChild(makeClone(originals[i]));
    }
  }

  function initTrack(track, viewportWidth) {
    if (!track || track.dataset.moduloTmReady === '1') return;

    var originals = Array.prototype.slice.call(track.children);
    if (originals.length === 0) return;

    var gap = getGap(track);
    var cycleWidth = measureCycle(originals, gap);
    if (cycleWidth <= 0) return; // not laid out yet — resize will retry

    var required = viewportWidth + cycleWidth;
    var copiesNeeded = Math.max(2, Math.ceil(required / cycleWidth));
    for (var c = 0; c < copiesNeeded; c++) cloneSet(track, originals);

    track.style.setProperty('--modulo-tm-cycle-width', cycleWidth + 'px');
    track.dataset.moduloTmReady = '1';
  }

  function initMarquee(el) {
    if (REDUCE) return;
    var viewportWidth = el.offsetWidth || document.documentElement.clientWidth;
    var tracks = el.querySelectorAll('.modulo-tm__track');
    for (var i = 0; i < tracks.length; i++) initTrack(tracks[i], viewportWidth);
  }

  function bootstrap() {
    var els = document.querySelectorAll('[data-modulo-tm]');
    for (var i = 0; i < els.length; i++) initMarquee(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-measure on resize so wider screens stay filled. Only ADD clones.
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (REDUCE) return;
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var els = document.querySelectorAll('[data-modulo-tm]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var tracks = el.querySelectorAll('.modulo-tm__track');
        for (var t = 0; t < tracks.length; t++) {
          var track = tracks[t];
          if (track.dataset.moduloTmReady !== '1') {
            initTrack(track, el.offsetWidth || document.documentElement.clientWidth);
            continue;
          }
          var needed = (el.offsetWidth || 0) * 2;
          var safety = 0;
          while (track.scrollWidth < needed && safety < 4) {
            var snapshot = Array.prototype.slice.call(track.children);
            for (var j = 0; j < snapshot.length; j++) {
              track.appendChild(makeClone(snapshot[j]));
            }
            safety++;
          }
        }
      }
    }, 200);
  });

  // Theme editor: re-init when this section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-modulo-tm]') : null;
    if (el) initMarquee(el);
  });
})();
